<template>
<panel>
    <p slot="header">
        {{ item.first_name + ' ' + item.last_name }} <span class="gray">(administrator)</span>
    </p>

    <p slot="actions">
        <ui-button type="flat" icon="navigate_before" color="primary" @click="$router.push({name: 'admin.users.dashboard'})">Wróć do administratorów</ui-button>
        <ui-button type="flat" icon="mode_edit" color="primary" @click="edit">Edytuj administratora</ui-button>
    </p>

    <table class="table info-table">
        <tr>
            <th class="short">
                Imię i nazwisko
            </th>
            <td>
                {{ item.first_name + ' ' + item.last_name }}
            </td>
        </tr>
        <tr>
            <th>
                E-mail
            </th>
            <td>
                {{ item.email }}
            </td>
        </tr>

    </table>
</panel>
</template>

<script>
import Users from './../../services/Users'
import Loading from './../../mixins/Loading'
import Notify from './../../mixins/Notify'

export default {
  mixins: [Loading, Notify],
  data () {
    return {
      item: Users.getBaseItem(),
      id: null
    }
  },
  mounted () {
    this.id = this.$route.params.id
    this.getItem(this.id)
  },
  methods: {
    edit () {
      this.$router.push({name: 'admin.users.edit', params: {id: this.id}})
    },
    getItem (id) {
      this.setLoading(true)
      Users.get(id).then((res) => {
        this.item = res.data.item
        this.setLoading(false)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// Show.vue?e3df1e52